





















import Vue from "vue";
import TheAppNavigation from "@/menu/components/TheAppNavigation.vue";
import { httpService } from "@/common/services/HttpService";
import { AxiosError } from "axios";
import { ElementColors } from "@/common/theme/ElementColors";
import { storeService } from "@/common/services/StoreService";

export default Vue.extend({
  name: "App",
  components: { TheAppNavigation },
  data: () => {
    return {
      Colors: ElementColors,
      errorSnackbar: false as boolean,
      errorSnackbarText: "" as string,
      storeService,
    };
  },
  mounted() {
    httpService.addErrorListener((error: AxiosError) => {
      this.errorSnackbar = true;
      this.errorSnackbarText = error.message;
    });
  },
});
